export const RiderFilteredData = [
  { id: '1', name: 'Team', type: 'TEAM' },
  { id: '2', name: 'Category', type: 'CATEGORY' },
  { id: '3', name: 'Division', type: 'DIVISION' },
];

export const ShowMangeRiderFilteredData = [
  { id: '1', name: 'Team', type: 'TEAM' },
  { id: '1', name: 'Category', type: 'CATEGORY' },
  { id: '2', name: 'Division', type: 'DIVISION' },
];

export const ShowFilteredData = [
  { id: '1', name: 'Category', type: 'CATEGORY' },
  { id: '2', name: 'Division', type: 'DIVISION' },
];
